import React, { useState } from 'react'
import BarChart from './BarChart'
import LineChart from './LineChart'
import styled from 'styled-components'


const ChartsContainer = () => {
  const [barChart, setBarChart] = useState(true)
  return (
    <Wrapper>
      <h4>Yearly Starting and Effective Rents</h4>
      <button type='button' onClick={() => setBarChart(!barChart)}>
        {barChart ? 'Line Chart' : 'Bar Chart'}
      </button>
      {barChart ? <BarChart/> : <LineChart/>}
    </Wrapper>
  )
}
export default ChartsContainer

const Wrapper = styled.section`
  margin-top: 4rem;
  text-align: center;
  button {
    background: transparent;
    border-color: transparent;
    text-transform: capitalize;
    color: blue;
    font-size: 2rem;
    cursor: pointer;
  }
  h4 {
    text-align: center;
    margin-bottom: 1.25rem;
    color: green;
  }
`
